import $http from '@/libs/axios'

export default class InstagramAccountsApi {
  static async addAccount(data: any) {
    return (await $http.post('instagram/account/add', data)).data
  }

  static async updateAccount(accountId: any, data: any) {
    return (await $http.post(`admin/instagram/accounts/update/${accountId}`, data)).data
  }

  static async renewAccount(accountId: any) {
    return (await $http.get(`admin/instagram/accounts/renew/${accountId}`)).data
  }

  static async blockAccount(accountId?: number) {
    return (await $http.get(`admin/instagram/accounts/block/${accountId}`)).data
  }

  static async addPermissions(accountId?: number) {
    return (await $http.get(`admin/instagram/accounts/add-permissions/${accountId}`)).data
  }

  static async checkPermissions(accountId?: number) {
    return (await $http.get(`admin/instagram/accounts/check-permissions/${accountId}`)).data
  }

  static async deleteAccount(accountId: number) {
    return (await $http.delete(`admin/instagram/accounts/delete/${accountId}`)).data
  }

  static async deleteAccountByOwner(accountId: number) {
    return (await $http.delete(`instagram/accounts/${accountId}`)).data
  }

  static async checkTokens() {
    return (await $http.get('instagram/accounts/token-status')).data
  }

  static async addMenu(pageId?: number) {
    return (await $http.get(`admin/instagram/accounts/add-menu/${pageId}`)).data
  }

  static async deleteMenu(pageId?: number) {
    return (await $http.get(`admin/instagram/accounts/delete-menu/${pageId}`)).data
  }

  static async getAccounts() {
    return (await $http.get('admin/instagram/accounts')).data
  }
}
